import {IBaseLookup} from "./Ibase.lookup";

export namespace ModalityDuration {

    export const lookupName: string = "ModalityDuration";

    export interface ModalityDurationOverride {
        modalityOverrideKey: number;
        spsCodeKey: number;
        modalityKey: number;
        duration: number;
        lastUpdated: Date;
    }

    export interface ModalityDurationDS extends IBaseLookup {
        modalityDurationOverride: ModalityDurationOverride[];
    }
}
